import React from "react";
import { FitCheckHome } from "../apps/fit-check";
import { Layout } from "../components";

const Home: React.FC = () => {
  return (
    <Layout title="FitCheckr">
      <FitCheckHome />
    </Layout>
  );
};

export default Home;
